import * as React from "react";
import { useSocketContext } from "../websocket/websocketProvider";
import { useToast } from "./ToastModalContext";
import { useLocation, useNavigate } from "react-router-dom";

export interface OrderContextData {
    isCreditCardPurchaseCompleted: boolean;
    orderData: any;
}

export enum EventsTypes {
    StartTransactionEvent = "StartTransactionIntegrationEvent",
    UpdateConnectorEvent = "UpdateConnectorStatusIntegrationEvent",
    StopTransactionEvent = "StopTransactionIntegrationEvent",
}

export interface OrderEvent {
    id: string;
    creationDate: Date | number | any;
    eventType: EventsTypes;
    order: {
      orderOtId: number;
      orderPaymentProvider: string;
      orderState: string;
    };
}

export interface OrderProviderProps {
    children: React.ReactNode;
    eventData?: OrderEvent | undefined;
    eventType?: EventsTypes | undefined;
}

const OrderContext = React.createContext<OrderContextData>(
  {} as OrderContextData
);

function OrderProvider({ children }: OrderProviderProps) {
  const value = useSocketContext();

  const [isCreditCardPurchaseCompleted, setIsCreditCardPurchaseCompleted] = React.useState(false);
  const [orderData, setOrderData] = React.useState();
  const navigate = useNavigate();
  const {showToast} = useToast();
  const location = useLocation();

  const routePaths = location.pathname.split('/');

  React.useEffect(() => {
    let jsonArray = value.messages?.map(jsonString => JSON.parse(jsonString));
    if(jsonArray?.length > 0) {
        jsonArray?.forEach( json => {
            if(json?.order){
              if(json?.order?.orderPaymentMethodData) {
                const orderPaymentMethodData = JSON.parse(json?.order?.orderPaymentMethodData);
                if (
                    json.order?.orderOtId === 0 &&
                    json.order?.orderState === "paid"
                  ) {
                    showToast({
                      title:  `Crédito adicionado com sucesso`,
                      messageModal: `O valor de R$ ${json.order?.orderAmmount} foi adicionado ao seu crédito.`,
                      textEnterButton: 'Recibo',
                      allowButtonClosed: true,
                      handleEnterButton: () => navigate(`${routePaths[1]}/extract/credit/${json.order?.orderId}`),
                      closeButtonText: 'Fechar'
                    })
                    setIsCreditCardPurchaseCompleted(true);
                    return;
                  }
                  if (
                    json.order?.orderOtId === 0 &&
                    json.order?.orderState === "canceled"
                  ) {
                    showToast({
                      title:  `Não autorizado`,
                      messageModal: `A transação no cartão de crédito ${orderPaymentMethodData?.description} de R$ ${json.order?.orderAmmount} foi negada.`,
                      closeButtonText: 'Fechar'
                    })
                    setIsCreditCardPurchaseCompleted(false);
                    return;
                }
                setOrderData(json?.order);
              }
            }
        })
    }
  }, [value.messages]);

  return (
    <OrderContext.Provider value={{ isCreditCardPurchaseCompleted, orderData}}>
      {children}
    </OrderContext.Provider>
  );
}

const useOrderContext = () => React.useContext(OrderContext);

export { OrderProvider, useOrderContext };
